var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('MomoNav', [_c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_redeem_active.png")
    }
  })])]), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoRedeemRecord'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_redeem_record.png")
    }
  })])], 1), _c('div', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoPointRecord'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_button_point_record.png")
    }
  })])], 1)]), _c('div', [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffHuggiesMomoMemberIndex'
      }
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("./images/momo_profile_back_btn.png")
    }
  })]), _c('img', {
    staticClass: "layoutMomo-title",
    attrs: {
      "src": require("./images/momo_title_redeem.png")
    }
  })], 1), _c('div', {
    staticClass: "list mt-3"
  }, _vm._l(_vm.gifts, function (gift) {
    return _c('MomoProductItem', {
      key: gift.id,
      attrs: {
        "product": gift,
        "fetchGifts": _vm.fetchGifts
      }
    });
  }), 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }